import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import SummaryCard from '../components/dashboard/SummaryCard';
import PendingList from '../components/dashboard/PendingList';
import { getDashboard } from '../view/HTTPService';

const cobrarBody = (rowData) => (
    <Button
        label="Cobrar"
        icon="pi pi-envelope"
        className="p-button-sm"
        onClick={() => console.log('Cobrar', rowData)}
    />
);

const annuityBody = (rowData) => rowData.lastPaidAnnuity ?? '—';

const affiliateColumns = [
    { field: 'name',            header: 'Nome' },
    { field: 'lastPaidAnnuity', header: 'Última anuidade paga', body: annuityBody },
    { field: 'gym',             header: 'Dojo' },
    { field: 'state',           header: 'Estado' },
    { field: 'action',          header: 'Ação', body: cobrarBody },
];

const gymColumns = [
    { field: 'name',            header: 'Nome' },
    { field: 'lastPaidAnnuity', header: 'Última anuidade paga', body: annuityBody },
    { field: 'state',           header: 'Estado' },
    { field: 'action',          header: 'Ação', body: cobrarBody },
];

export default function DashboardPage() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        getDashboard()
            .then(d => { setData(d); setLoading(false); })
            .catch(() => { setError(true); setLoading(false); });
    }, []);

    if (loading) {
        return (
            <div className="flex justify-content-center mt-4">
                <ProgressSpinner />
            </div>
        );
    }

    if (error) {
        return (
            <div className="p-4 mt-4">
                <p style={{ color: '#ef4444' }}>Erro ao carregar dashboard</p>
            </div>
        );
    }

    return (
        <div className="p-4">
            <h1 className="mb-3">Dashboard Administrativo {data?.year}</h1>

            <div className="grid">
                <div className="col-12 md:col-3">
                    <SummaryCard label="Filiados Total" value={data?.affiliates?.total} icon="pi pi-users" />
                </div>
                <div className="col-12 md:col-3">
                    <SummaryCard label="Filiados Pagos" value={data?.affiliates?.paid} variant="success" icon="pi pi-check-circle" />
                </div>
                <div className="col-12 md:col-3">
                    <SummaryCard label="Filiados Pendentes" value={data?.affiliates?.pending} variant="danger" icon="pi pi-exclamation-circle" />
                </div>
                <div className="col-12 md:col-3">
                    <SummaryCard label="Ano" value={data?.year} icon="pi pi-calendar" />
                </div>
            </div>

            <div className="grid mt-3">
                <div className="col-12 md:col-4">
                    <SummaryCard label="Dojos Filiados" value={data?.gyms?.affiliated} icon="pi pi-home" />
                </div>
                <div className="col-12 md:col-4">
                    <SummaryCard label="Dojos Pagos" value={data?.gyms?.paid} variant="success" icon="pi pi-check-circle" />
                </div>
                <div className="col-12 md:col-4">
                    <SummaryCard label="Dojos Pendentes" value={data?.gyms?.pending} variant="danger" icon="pi pi-exclamation-circle" />
                </div>
            </div>

            <PendingList
                title="Filiados com anuidade pendente"
                items={data?.pendingAffiliates ?? []}
                columns={affiliateColumns}
            />

            <PendingList
                title="Dojos com anuidade pendente"
                items={data?.pendingGyms ?? []}
                columns={gymColumns}
            />
        </div>
    );
}
